module.exports = __webpack_public_path__ + "img/mobile-banner.f0e26e3c.png";